import gql from 'graphql-tag';

export const CHECK_FIELDS_IS_FILLED = gql`
    query checkFieldsIsFilled($input: SignnowFieldsInput!) {
        checkFieldsIsFilled(input: $input) {
          result
        }
    }
`;
